import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Loading from './components/mixin/Loading'
import store from './store'
import Buefy from 'buefy'
import server from './server.js'
import './filters'
import 'mdi/scss/materialdesignicons.scss'
import 'vue-datetime/dist/vue-datetime.css'
import VueApexCharts from 'vue-apexcharts'

Vue.config.productionTip = false

Vue.use(Buefy)
Vue.use(VueApexCharts)
Vue.component('Apexchart', VueApexCharts)
Vue.mixin(Loading)
Vue.prototype.$http = server

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

